import { FormInstance } from "antd";
import { ExamGroup } from "@types";
import { QuestionsRandom } from "./groups-form-type/QuestionsRandom";
import { QuestionsSelectRandom } from "./groups-form-type/QuestionsSelectRandom";
import { setTimeWithSeconds } from "../../helpers";

export const setQuestionGroupFormValues = (
    groupSettingsForm: FormInstance,
    examGroup: ExamGroup
) => {
    const examGroupTemp = {
        ...examGroup,
    }
    if (examGroupTemp.examGroupProperties == null) {
      delete examGroupTemp.examGroupProperties;
    }
    
    groupSettingsForm.setFieldsValue(examGroupTemp)
    
    if (examGroup.timeInSeconds) {
        groupSettingsForm.setFieldValue("timeRestriction", true)
      groupSettingsForm.setFieldsValue({
        timeInSeconds: setTimeWithSeconds(examGroup.timeInSeconds)
      });
    }
    
    if (examGroup.percentageToPass) {
      groupSettingsForm.setFieldValue("percentage", true)
    }
}

export const chooseFormByType = (questionGroupType: number, groupSettingsForm: FormInstance, examGroup: ExamGroup) => {

    if (questionGroupType === 2) {
        return <QuestionsRandom examGroup={examGroup} />
    } else if (questionGroupType === 3) {
        return <QuestionsSelectRandom form={groupSettingsForm} examGroup={examGroup}/>
    }

    return <></>
}